// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buttons-wrapper[data-v-6744f462]{padding:0 28px}@media(min-width:1201px){.buttons-wrapper[data-v-6744f462]{padding-left:0;padding-right:20px;position:relative}.buttons-wrapper[data-v-6744f462]:after{background-color:rgba(189,202,210,.5);content:\"\";height:42px;position:absolute;top:50%;transform:translateY(-50%);width:1px;right:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
